/* eslint-disable */ 
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRs from '@appbaseio/reactivesearch-vue'
import './simple-sidebar.css'
import VModal from 'vue-js-modal'
import BookPanel from './components/BookPanel'
import BookDisplay from './components/BookDisplayPanel'
// import VueAnalytics from 'vue-analytics'
// import VueGtm from 'vue-gtm'

Vue.use(VModal, { dialog: true })
//Vue.use(VModal)
Vue.use(VueRs)
Vue.config.productionTip = false

// Config Vue Google Tag Manager
// Vue.use(VueGtm, {
//   id: 'GTM-PW65XFW', //or ['GTM-xxxxxxx', 'GTM-xxxxxxx'], // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
//   enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//   debug: true, // Whether or not display console logs debugs (optional)
//   loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//   vueRouter: router // Pass the router instance to automatically sync with router (optional)
//   //ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
// });

// Config Google Analytics
// Vue.use(VueAnalytics, {
//   id: 'UA-140966232-8',
//   router
// })

Vue.component('book-panel', BookPanel)
Vue.component('book-display-panel',BookDisplay)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


$(document).ready(function() {
  $("#menu-toggle").click(function(e) {
    e.preventDefault();
    $("#wrapper").toggleClass("toggled");
  });
})